<template>
  <div>
    <el-form-item :label="$t('显示工号')">
      <el-switch v-model="data.showWokerNumber"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-createuser",
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

